import React from 'react'
import { Input, Select } from 'antd'
import { parse, format } from 'libphonenumber-js'

const Option = Select.Option

const getValue = value => {
  try {
    const phone = parse(value)
    const formatted = format(phone, 'International')
    const country = phone.country === 'US' ? '+1' : '+44'

    return { country, body: formatted.replace(country + ' ', '') }
  } catch (e) {
    const country = value && value.startsWith('+44') ? '+44' : '+1'
    return { country, body: value ? value.replace(country, '') : '' }
  }
}

class InputPhone extends React.Component {
  state = {
    country: '+1',
    body: ''
  }

  static getDerivedStateFromProps (nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps) {
      return getValue(nextProps.value)
    }
    return null
  }

  onCountryChange = country => {
    const { onChange } = this.props

    try {
      const phone = parse(country + this.state.body)
      const formatted = format(phone, 'International')

      this.setState({ country, body: formatted.replace(country + ' ', '') })
      onChange(country + phone.phone)
    } catch (e) {
      this.setState({ country })
      if (this.state.body) onChange(country + this.state.body)
      else onChange(country)
    }
  }

  onBodyChange = e => {
    let body = e.target.value
    const { onChange } = this.props

    try {
      const phone = parse(this.state.country + body)
      const formatted = format(phone, 'International')

      this.setState({ body: formatted.replace(this.state.country + ' ', '') })
      onChange(this.state.country + phone.phone)
    } catch (e) {
      this.setState({ body })
      if (body) onChange(this.state.country + body)
      else onChange('')
    }
  }

  render () {
    const { value, onChange, disabled, ...inputProps } = this.props

    const countrySelector = (
      <Select
        value={this.state.country}
        onChange={this.onCountryChange}
        style={{ width: 70, textAlign: 'right' }}
        disabled={disabled}
      >
        <Option value='+1'>&nbsp;+1</Option>
        <Option value='+44'>&nbsp;+44</Option>
      </Select>
    )

    return (
      <Input
        addonBefore={countrySelector}
        value={this.state.body}
        onChange={this.onBodyChange}
        disabled={disabled}
        {...inputProps}
      />
    )
  }
}

export default InputPhone
